export default function(target, eventName, bubbles = true, cancelable = true, detail = {}) {
  const customEvent = new CustomEvent(eventName, {
    bubbles,
    cancelable,
    detail
  });
  target.dispatchEvent(customEvent);
}
